export default function initializeParallax() {
    mainParallax()
    homeSplashParallax()
}
function mainParallax() {
    const elements = [...document.querySelectorAll('.parallax')]

    window.addEventListener('scroll', (e) => {
        let scrollY = window.scrollY || document.body.scrollTop || window.pageYOffset;
        const visibleRange = [scrollY, scrollY + innerHeight];
        for (let a = 0; a < elements.length; a++) {
            let element = elements[a]
            if (!element) {
                continue
            }
            
            let node = element
            let offsetY = node.offsetTop

            while (node != document.body) {
                node = node.parentNode
                offsetY += node.offsetTop
            }

            const elementRange = [
                element.offsetTop + offsetY,
                element.offsetTop + offsetY + element.offsetHeight
            ]

            const offset = visibleRange[0] - elementRange[0]
            element.style.transform = 'translateY(' + (offset * 0.4) + 'px)'
        }
    })
}

function homeSplashParallax() {
    const splashContainer = document.querySelector('div.home-splash')

    if (!splashContainer) {
        return
    }

    window.addEventListener('scroll', (e) => {
        let scrollY = window.scrollY || document.body.scrollTop || window.pageYOffset;
        splashContainer.style.transform = 'translateY(' + scrollY / 2.5 + 'px)'
    })
}
